module.exports = [
  require('./earth_tremor'),
  require('./earthbind'),
  require('./elemental_bane'),
  require('./enemies_abound'),
  require('./enervation'),
  require('./erupting_earth'),
]
